interface Environment {
  API_CLIENT_URL: string;
  ADYEN_CLIENT_KEY: string;
  ADYEN_ENVIRONMENT:
  | 'test'
  | 'live'
  | 'live-us'
  | 'live-au'
  | 'live-apse'
  | 'live-in';
  HEAP_ID: string;
  STAGE: 'local' | 'dev' | 'prod' | ''
}

export const environment: Environment = {
  // API CONFIG
  API_CLIENT_URL:
    'https://foy3f1r7ue.execute-api.eu-central-1.amazonaws.com/patsta32/',

  // ADYEN CONFIG
  ADYEN_CLIENT_KEY: 'test_56X4WOB2INCDNHBNUTZCXDE7BERRONGH',
  ADYEN_ENVIRONMENT: 'test',

  // HEAP CONFIG
  HEAP_ID: '3680975755',

  STAGE: 'local'
};
